import 'angular/autocomplete/controllers';

const modules = [
    'ngRoute',
    'graphdb.framework.autocomplete.controllers'
];

angular.module('graphdb.framework.autocomplete', modules);
